import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Admin } from '../../models/admin.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { AdminResolver } from '../../resolver/admin.resolver';

@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss']
})
export class AdminListComponent extends BaseFormComponent<Admin> implements OnInit {

  data: Admin;
  currentEditId: number;
  currentTypeId: string;
  modalRef?: BsModalRef;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
      public activatedRoute: ActivatedRoute,
      private modalService: BsModalService,
      public myService: AdminService,
      public adminResolver: AdminResolver,
    ) { 
      super(activatedRoute);
    }

  ngOnInit() {
    this.loading();
    this.start();
  }

  start(){
    this.adminResolver.resolve( ).subscribe({
      next: (data) => {
        var newData = data;
        this.entity = newData;
        this.data = newData;
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error.error.message);
      }
    })
  }

  openModal(type:string, id:number = null) {
    this.currentEditId = id;
    this.currentTypeId = type;
    this.modalRef = this.modalService.show(this.modal,{class:"modal-m"});
  }

  closeModal() {
    this.modalRef?.hide();
  }
  
  confirmExcluir(id:number, type:string) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.loading();
        this.excluir(id, type);
      }
    });
  }
  excluir(id:number, type:string): void {
    this.loading();
    this.myService.deleteByType(id, type).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }

}
